import DetailsPayment from './details-payment'
export default DetailsPayment